import React from 'react';
import { IconSVG } from '../../../components';
import { getAccentColor } from '../../../utils';

const accentColor = getAccentColor();

const FAQ: React.FC = () => (
  <IconSVG width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16683 18.2448C11.5556 18.2448 13.5002 16.3002 13.5002 13.9115C13.5002 11.5227 11.5556 9.57812 9.16683 9.57812C6.777 9.57812 4.8335 11.5227 4.8335 13.9115C4.83458 16.3002 6.777 18.2448 9.16683 18.2448Z"
      fill="black"
    />
    <path
      d="M9.16667 19.3281C4.06308 19.3281 0.5 22.0007 0.5 25.8281V26.9115H17.8333V25.8281C17.8333 22.0007 14.2692 19.3281 9.16667 19.3281Z"
      fill="black"
    />
    <path
      d="M23.2502 10.6621H21.0835V7.41211H22.1668C23.3617 7.41211 24.3335 6.43928 24.3335 5.24544C24.3335 4.04944 23.3617 3.07878 22.1668 3.07878C20.9708 3.07878 20.0002 4.04944 20.0002 5.24544H17.8335C17.8335 2.85669 19.777 0.912109 22.1668 0.912109C24.5556 0.912109 26.5002 2.85669 26.5002 5.24544C26.5002 7.26044 25.1167 8.95911 23.2502 9.44228V10.6621Z"
      fill={accentColor}
    />
    <path
      d="M22.1668 13.9118C22.7651 13.9118 23.2502 13.4268 23.2502 12.8285C23.2502 12.2301 22.7651 11.7451 22.1668 11.7451C21.5685 11.7451 21.0835 12.2301 21.0835 12.8285C21.0835 13.4268 21.5685 13.9118 22.1668 13.9118Z"
      fill={accentColor}
    />
  </IconSVG>
);

export default FAQ;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/icons/FAQ.tsx